import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { ButtonMinimalComponent } from '@reconcept-platform/shared/ui/standalone/button';

@Component({
  selector: 'rcp-breadcrumb',

  template: `
    <rcp-button-minimal>
      <ng-content />
    </rcp-button-minimal>

    <span class="rcp-breadcrumb-separator">
      <fa-icon [icon]="faAngleRight"></fa-icon>
    </span>
  `,
  styles: `
    :host(:last-of-type) {
      .rcp-breadcrumb-separator {
        display: none;
      }
    }

    :host {
      display: inline-flex;
      gap: var(--spacing-sm);
    }
  `,
  imports: [ButtonMinimalComponent, FaIconComponent, ButtonMinimalComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class BreadCrumbComponent {
  protected readonly faAngleRight = faAngleRight;
}
